"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, _react.default.createElement("path", {
  d: "M.17 5.1c-.23.16-.23.4 0 .56l7.42 4.99c.22.15.6.15.82 0l7.42-4.99c.23-.15.23-.4 0-.56L8.4.12a.8.8 0 00-.82 0L.17 5.1zM8 9.81L1.42 5.38 8 .95l6.58 4.43L8 9.81zm-7 .53a.8.8 0 00-.83 0c-.23.15-.23.4 0 .55l7.42 5c.22.15.6.15.82 0l7.42-5c.23-.15.23-.4 0-.55a.8.8 0 00-.83 0l-7 4.7-7-4.7z"
}));

exports.default = _default;